@if (visible()) {
  @let desktop = isZeroDesktop() || isFinnetDesktop();
  <div class="scores-overview" [class.desktop]="desktop">
    <app-v3-overview-card-header
      icon="/v3/scores.svg"
      title="Scores"
      [updatedAt]="updatedAt()"
      actionLabel="Alle Scores"
      (navigate)="onNavigate()"
    ></app-v3-overview-card-header>

    @if (desktop) {
      <div class="score-cards">
        @for (tile of tiles(); track tile.key) {
          <app-v3-score-card
            [label]="tile.label"
            [value]="tile.value"
            [max]="tile.max"
            [colorVar]="tile.v3ColorVar"
            [isRatingSuspended]="tile.isRatingSuspended"
            role="button"
            tabindex="0"
            (click)="onNavigate(tile.key)"
            (keyup.enter)="onNavigate(tile.key)"
            (keydown.space)="$event.preventDefault(); onNavigate(tile.key)"
          ></app-v3-score-card>
        }
      </div>
    } @else {
      <div class="bars">
        @for (tile of tiles(); track tile.key) {
          <app-v3-score-bar
            [label]="tile.label"
            [value]="tile.value"
            [max]="tile.max"
            [colorVar]="tile.v3ColorVar"
            [isRatingSuspended]="tile.isRatingSuspended"
            role="button"
            tabindex="0"
            (click)="onNavigate(tile.key)"
            (keyup.enter)="onNavigate(tile.key)"
            (keydown.space)="$event.preventDefault(); onNavigate(tile.key)"
          ></app-v3-score-bar>
        }
      </div>

      @if (isFinnet()) {
        <button class="score-details" type="button" (click)="onNavigate()">
          <span>Score Details</span>
          <span class="caret"></span>
        </button>
      }
    }
  </div>
}
